import { useState } from "react";
import styled from "@emotion/styled";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters, tabs } from "./config";

import InvoiceStats from "./Components/Stats";

import useIsMobile from "../../hooks/useIsMobile";

import { TableTitle } from "../../utils/Common"

import { BasicFlex } from "../../utils/Common";

import WarningRoundedIcon from '@mui/icons-material/WarningRounded';


let WmContainer = styled(BasicFlex)`
  padding: 1.6rem;
`

let WMessage = styled(BasicFlex)`
  width: auto;
  gap: 2rem;
  align-items: flex-start;
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: .6px;
  font-weight: 600;

  .icon {
    width: fit-content;
  }

  .message {
    flex-grow: 1;
  }
`

const InvoiceList = () => {

  const { isMobile } = useIsMobile();

  let warning_msg = <WmContainer dir="column" gap="2rem">
    <div>
      This action cannot be undone. Are you sure you want to delete this?
    </div>
    
    <WMessage>
      <div className="icon">
        <WarningRoundedIcon color="warning" fontSize="large" />
      </div>
      <div className="message">Warning! All Repairs and Custom Orders attached to this invoice will be permanently deleted. Please make sure this is what you want to do.</div>
    </WMessage>
  </WmContainer>

  return (
    <>
    <TableTitle><InventoryRoundedIcon /><span>Invoice List</span></TableTitle>
    {!isMobile ? <InvoiceStats /> : null}
    <Table tableId="invoices" title="Invoice" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-date" idKey="invoice_id" fieldsToSearch={["Customer", "Invoice Number"]} NoTitle={true} del_warning_msg={warning_msg} tabField="paid_status" tabs={tabs} />
    </>
  );
};

export default InvoiceList;